import script from "./SlotSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./SlotSelector.vue?vue&type=script&setup=true&lang=js"

import "./SlotSelector.vue?vue&type=style&index=0&id=ffd9adf6&scoped=true&lang=css"
import "./SlotSelector.vue?vue&type=style&index=1&id=ffd9adf6&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ffd9adf6"]])

export default __exports__